import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useAuthStore } from '../store/authStore';
import { Helmet } from 'react-helmet-async';

function AuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { handleAuthCallback } = useAuthStore();

  useEffect(() => {
    const processAuth = async () => {
      const error = searchParams.get('error');
      if (error) {
        navigate(`/auth/error?error=${encodeURIComponent(error)}`);
        return;
      }

      // The backend OAuth callback issues a one-time exchange code in the URL
      // and stores the JWT against it in the user's session. We POST the code
      // back here to receive the JWT in a response body — this keeps the JWT
      // out of the URL, browser history, server access logs, and the Referer
      // header.
      const code = searchParams.get('code');
      if (!code) {
        navigate('/auth/error?error=no_code');
        return;
      }

      let token;
      try {
        const resp = await axios.post('/auth/exchange', { code });
        token = resp.data?.token;
      } catch (err) {
        const msg = err.response?.data?.error || err.message || 'exchange failed';
        navigate(`/auth/error?error=exchange_failed&message=${encodeURIComponent(msg)}`);
        return;
      }

      if (!token) {
        navigate('/auth/error?error=no_token');
        return;
      }

      const success = await handleAuthCallback(token);
      if (success) {
        navigate('/', { replace: true });
      } else {
        const storeError = useAuthStore.getState().error;
        navigate(`/auth/error?error=auth_failed&message=${encodeURIComponent(storeError || 'Unknown error')}`);
      }
    };

    processAuth();
  }, [searchParams, handleAuthCallback, navigate]);

  return (
    <>
      <Helmet><title>Authenticating - Rspamd Email Scanner</title></Helmet>
      <div className="flex flex-col items-center justify-center min-h-screen text-center">
        <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mb-6" />
        <h2 className="text-2xl font-semibold mb-2">Completing Authentication</h2>
        <p className="text-gray-500">Please wait while we complete your authentication...</p>
      </div>
    </>
  );
}

export default AuthCallback;
